function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable react-hooks/rules-of-hooks, react/display-name */
import React from "react";
const createFetchFederatedComponentCtx = ({
  remotes
}, previous) => {
  const context = _extends({
    components: {},
    chunks: [],
    promises: new Map()
  }, previous, {
    loadFederatedComponent(id, remote, module, props) {
      if (context.promises.has(id)) {
        return;
      }
      context.components[id] = () => null;
    }
  });
  return context;
};
export default createFetchFederatedComponentCtx;